import React, { useEffect, useMemo, useState } from 'react'
import { Card, Table, Form, Input, DatePicker, Button, Space } from 'antd'
import moment from 'moment'
import { getUserLogsAPI } from '@/apis/userLog'

const { RangePicker } = DatePicker

const UserLogPage = () => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [originData, setOriginData] = useState([])
  const [dataSource, setDataSource] = useState([])

  const columns = useMemo(() => ([
    { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
    { title: '事件名称', dataIndex: 'logName', key: 'logName' },
    { title: '事件详情', dataIndex: 'logDetail', key: 'logDetail' },
    { title: '项目ID', dataIndex: 'projectId', key: 'projectId', width: 100 },
    { title: '用户ID', dataIndex: 'userId', key: 'userId', width: 100 },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt', render: (v) => v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : '' },
  ]), [])

  const fetchData = async () => {
    setLoading(true)
    try {
      const res = await getUserLogsAPI()
      // 兼容后端返回格式 { code, msg, data }
  const list = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : [])
  setOriginData(list)
  setDataSource(list)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleSearch = () => {
    const { userId, logName, createdAt } = form.getFieldsValue()
  let filtered = [...originData]
    if (userId) {
      const idNum = Number(userId)
      filtered = filtered.filter(x => String(x.userId) === String(idNum))
    }
    if (logName) {
      filtered = filtered.filter(x => x.logName?.toLowerCase().includes(logName.toLowerCase()))
    }
    if (createdAt && createdAt.length === 2) {
      const [start, end] = createdAt
      const s = moment(start?.valueOf ? start.valueOf() : start).valueOf()
      const e = moment((end?.valueOf ? end.valueOf() : end)).endOf('day').valueOf()
      filtered = filtered.filter(x => x.createdAt && moment(x.createdAt).valueOf() >= s && moment(x.createdAt).valueOf() <= e)
    }
    setDataSource(filtered)
  }

  const handleReset = () => {
    form.resetFields()
    fetchData()
  }

  return (
    <Card title="用户日志查看">
      <Form form={form} layout="inline" style={{ marginBottom: 16 }}>
        <Form.Item label="用户ID" name="userId">
          <Input placeholder="输入用户ID" allowClear style={{ width: 180 }} />
        </Form.Item>
        <Form.Item label="日志事件" name="logName">
          <Input placeholder="输入事件名称" allowClear style={{ width: 220 }} />
        </Form.Item>
        <Form.Item label="创建时间" name="createdAt">
          <RangePicker showTime style={{ width: 320 }} />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button type="primary" onClick={handleSearch}>筛选</Button>
            <Button onClick={handleReset}>重置</Button>
          </Space>
        </Form.Item>
      </Form>

      <Table
        rowKey="id"
        loading={loading}
        dataSource={dataSource}
        columns={columns}
        pagination={{ pageSize: 10 }}
      />
    </Card>
  )
}

export default UserLogPage
